import React, {useState, useEffect, useMemo} from 'react';
import { useNavigate, Link} from 'react-router-dom';
import '../styles/global.css'; // Seu CSS global
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { AccessAlarm, ThreeDRotation, ThumbUpAlt, ThumbDownOffAlt } from '@mui/icons-material';
import MenuAssociados from '../components/MenuAssociados';

function Agendas() {
    const [searchTerm, setSearchTerm] = useState('');
    const [agendas, setAgendas] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectStatus, setSelectStatus] = useState('');
    const [isLoadingMOD, setIsLoadingMOD] = useState(false);
    const [menuAberto, setMenuAberto] = useState(false);
    const associado = parseInt(sessionStorage.getItem('pesAssociado'));
    //era localStorage.getItem('pesAssociado') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente
    const navigate = useNavigate();
    const loggedIn = sessionStorage.getItem('loggedIn');
    //era localStorage.getItem('loggedIn') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente
    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    
    const customFormatSmallDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    
    useEffect(() => {
      if (loggedIn === false)
      {
        navigate('/Login');
        window.location.reload();
      }
    }, []);

    useEffect(() => {
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        setIsLoadingMOD(true);
        axios
            .get(
                process.env.REACT_APP_API_URL +
                '/routes.php?metodo=obtemAgendas',
                {
                    headers: {
                        "X-Access-Token": token,
                        "Content-Type": "application/json; charset=UTF-8"
                    }
                }
            )
            .then(response => {
                setAgendas(response.data);
                setIsLoadingMOD(false)
            })
            .catch(error => {
                let ret = error.message;
                setIsLoadingMOD(false);
                if (ret.includes("401")) {
                    console.log("token inválido!")
                }
                else if (ret.includes("403")) {
                    //window.location.reload();
                }
            })
    },[])

    //console.log(agendas);
    function handleSelectStatusChange(event) {
        sessionStorage.selectStatusRegistroAgendas = event.target.value
        setSelectStatus(sessionStorage.selectStatusRegistroAgendas)
    }

    function handleNovaAgenda() {
        const agenda = {
            IdAgenda: 0,
            ageData: '',
            ageHoraInicial: '',
            ageHoraFinal: '',
            ageDescricao: '',
            ageObservacoes: '',
            ageAnexo: '',
            ageStatus: 1,
            ageCriadoPor: '',
            ageCriadoEm: customFormatDate,
            ageModificadoPor: '',
            ageModificadoEm: customFormatDate,
            ageCodigoGUID: ''
        };
        navigate('/Agenda', { state: { agendaInfo: agenda } });
    }

    function handleEditAgenda(agenda) {
        sessionStorage.setItem(`itemClicladoId`, agenda.IdAgenda);
        navigate('/Agenda', { state: { agendaInfo: agenda } });
    }

    function handleExibirPDF(agenda) {
        if (agenda.ageAnexo) {
            navigate('/ViewPDF', { state: { registro: agenda } });
        }
    }

    function handleChangeStatus(agenda) {
        if (window.confirm("Deseja realmente alterar o status desta agenda?")) { 
            sessionStorage.setItem(`itemClicladoId`, agenda.IdAgenda);
            gravarAlteracaoStatus(agenda);
        } else {
            return;
        }
    }

    function gravarAlteracaoStatus(agenda) {
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        const novoStatus = agenda.ageStatus === 1 ? 0 : 1;
        axios
            .post(
                process.env.REACT_APP_API_URL +
                '/routes.php?metodo=alterarStatusAgenda',
                {
                    IdAgenda: agenda.IdAgenda,
                    ageStatus: novoStatus,
                    ageAlteradoPor: sessionStorage.nomeUsuario,
                    ageAlteradoEm: customFormatDate
                },
                {
                    headers: {
                        "X-Access-Token": token,
                        "Content-Type": "application/json; charset=UTF-8"
                    }
                }
            )
            .then(response => {
                // Atualizar o status da agenda na lista localmente
                setAgendas(prevAgendas =>
                    prevAgendas.map(a =>
                        a.IdAgenda === agenda.IdAgenda 
                        ? { ...a, ageStatus: novoStatus } 
                        : a
                    )
                );
            })
            .catch(error => {
                console.error("Erro ao alterar status da agenda:", error);
            });
    }

    const toggleMenu = () => {
        setMenuAberto(!menuAberto);
    };

    const toggleLogoff = () => {
    localStorage.clear();
    localStorage.setItem('loggedIn', false);
    localStorage.removeItem('user');
    sessionStorage.clear();
    
    navigate('/');
    window.location.reload();
    }


  //salvar log de navegação
    useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Navegação",
      logModulo: "Página de Agendas",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
    }, []);

    const useSortableData = (items, config = null) => {
        const [sortConfig, setSortConfig] = useState(config);

        const sortedItems = useMemo(() => {
          let sortableItems = [...items];
          if (sortConfig !== null) {
            sortableItems.sort((a, b) => {
              if (a[sortConfig.key] < b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
              }
              if (a[sortConfig.key] > b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
              }
              return 0;
            });
          }
          return sortableItems;
        }, [items, sortConfig]);

        const requestSort = key => {
          let direction = 'ascending';
          if (
            sortConfig &&
            sortConfig.key === key &&
            sortConfig.direction === 'ascending'
          ) {
            direction = 'descending';
          }
          setSortConfig({ key, direction });
        };

        return { items: sortedItems, requestSort, sortConfig };
    };

    const { items, requestSort, sortConfig } = useSortableData(agendas);

    const getClassNamesFor = name => {
        if (!sortConfig) {
            return;
        }
        return sortConfig.key === name ? sortConfig.direction : undefined;
    };

    //identificar a resolução da tela para ajustar o tamanho da tabela
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
    };
    }, []);

    //vai para linha de foco após edição
    useEffect(() => {
    
    const itemClicadoId = sessionStorage.getItem('itemClicladoId');

    if (itemClicadoId) {
        const elementoLinha = document.getElementById(`agenda-${itemClicadoId}`);
        
        if (elementoLinha) {
        // Rola até a linha clicada de forma suave
        setTimeout(() => {
            elementoLinha.scrollIntoView({ behavior: 'smooth', block: 'center' });
            // Destaque visual temporário opcional (ex: piscar a linha)
            elementoLinha.style.backgroundColor = '#fff9c4'; 
            setTimeout(() => elementoLinha.style.backgroundColor = '', 3000);
        }, 100); // Um pequeno delay garante que o HTML já renderizou

        // 2. Limpa o ID para não rolar de novo se o usuário atualizar a página (F5)
        sessionStorage.removeItem('itemClicadoId');
        }
    }
    }, [items]);

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div>
                    <MenuAssociados />
                </div>
                <div>
                    <div className='headerMain'>
                        <label className='labelTitulo' >AGENDA</label>
                        <label className='labelSubTitulo'>Eventos, Encontros e Rolês</label>
                    </div>
                    {/* Modal de edição */}
                    <div>
                        {modalOpen && (<Agenda setOpenModal={setModalOpen} agendaInfo={modalInfo} />)}
                    </div>
                    {/* Pesquisa filtro e botão nnovo */}
                    <div className="containerBarraPesquisa">
                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                            <button className="buttonModalPadrao" onClick={handleNovaAgenda}>
                                NOVO EVENTO
                            </button> ) : ('')}

                        <input className='inputBarraPesquisa'
                        placeholder='PESQUISAR'
                        type='text'
                        id='inputPesquisa'
                        name='inputPesquisa'
                        onChange={event => {
                            setSearchTerm(event.target.value);
                        }}
                        />
                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        <select className="selectStatusPesquisa"
                        name="selectStatusRegistroAgendas"
                        selected={sessionStorage.selectStatusRegistroAgendas !== undefined ? sessionStorage.selectStatusRegistroAgendas : '99'}
                        onChange={event => {
                            handleSelectStatusChange(event)
                        }}
                        >
                        <option value={'99'} selected={sessionStorage.selectStatusRegistroAgendas && sessionStorage.selectStatusRegistroAgendas === '99' ? true : false} >TODOS</option>
                        <option value={'1'} selected={sessionStorage.selectStatusRegistroAgendas && sessionStorage.selectStatusRegistroAgendas === '1' ? true : true} >ATIVOS</option>
                        <option value={'0'} selected={sessionStorage.selectStatusRegistroAgendas && sessionStorage.selectStatusRegistroAgendas === '0' ? true : false} >INATIVOS</option>
                        </select>
                        ) : ('')}
                    </div>
                </div>

                <div className="tabelaPadrao">
                    {windowWidth < 769 ? (
                        <div className="tabelaPadrao">
                            {isLoadingMOD ? (
                                <tr>
                                    <td colSpan="6" style={{ width: "100%", textAlign: "center"}}>
                                        <CircularProgress />
                                    </td>
                                </tr>
                            ) : (
                                items.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" style={{ width: "100%", textAlign: "center"}}>
                                            Nenhuma agenda cadastrada
                                        </td>
                                    </tr>
                                ) : (
                                    items
                                    .filter(val => {
                                        if (searchTerm === '') {
                                            if(sessionStorage.selectStatusRegistroAgendas !== undefined && sessionStorage.selectStatusRegistroAgendas === '99') {
                                                return val;
                                            } else if (sessionStorage.selectStatusRegistroAgendas !== undefined && sessionStorage.selectStatusRegistroAgendas !== '99') {
                                                if(parseInt(sessionStorage.selectStatusRegistroAgendas) === parseInt(val.ageStatus)) {
                                                    return val;
                                                }
                                            } else {
                                                return val;
                                            }
                                        } else if (
                                            val.ageData.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                            val.ageDescricao.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                            val.ageObservacoes.toLowerCase().includes(searchTerm.toLowerCase())
                                        ) {
                                            if(sessionStorage.selectStatusRegistroAgendas !== undefined && sessionStorage.selectStatusRegistroAgendas === '99') {
                                                return val;
                                            } else if (sessionStorage.selectStatusRegistroAgendas !== undefined && sessionStorage.selectStatusRegistroAgendas !== '99') {
                                                if(parseInt(sessionStorage.selectStatusRegistroAgendas) === parseInt(val.ageStatus)) {
                                                    return val;
                                                }
                                            } else {
                                                return val;
                                            }
                                        }
                                    })
                                    .map(agenda => (
                                        <div key={agenda.IdAgenda} 
                                        className="p2" style={{ cursor: 'pointer', borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '5px' }}
                                        >
                                            <div id={`agenda-${agenda.IdAgenda}`} onClick={() => handleEditAgenda(agenda)}>
                                                <div style={{ color: '#000', marginTop: '10px' }}><strong>Data: </strong>{ new Intl.DateTimeFormat('pt-BR').format(new Date(agenda.ageData))}</div>
                                                <div style={{ color: '#000', marginTop: '10px' }}><strong>Descrição: </strong>{agenda.ageDescricao}</div>
                                                <div style={{ color: '#000', marginTop: '10px' }}><strong>Observações: </strong>{agenda.ageObservacoes}</div>
                                            </div>
                                            <div>
                                                <div style={{ color: '#000', marginTop: '10px' }}>
                                                    {agenda.ageAnexo ? (
                                                        <button className="buttonGridPadrao" onClick={() => handleExibirPDF(agenda)}>
                                                            Anexo
                                                        </button>
                                                    ) : ''}
                                                </div>
                                                {parseInt(sessionStorage.pesAdmin) === 1 ? (
                                                <div style={{ color: '#000', marginTop: '10px' }}>
                                                    <label id={`agenda-${agenda.IdAgenda}`} style={{ color: parseInt(agenda.ageStatus) === 1 ? 'green' : 'red', cursor: 'pointer' }}>
                                                        <label style={{ cursor: 'pointer', verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => {handleChangeStatus(agenda)}}>
                                                            {parseInt(agenda.ageStatus) === 1 
                                                            ? 
                                                            <ThumbUpAlt style={{ color: 'green', marginRight: '5px', marginBottom: '-5px', cursor: 'pointer' }} /> 
                                                            : 
                                                            <ThumbUpAlt style={{ color: 'red', marginRight: '5px', marginBottom: '-5px', cursor: 'pointer' }} />}
                                                            
                                                            {parseInt(agenda.ageStatus) === 1 ? ' ATIVA - Alterar para inativa' : ' INATIVA - Alterar para ativa'}
                                                        </label>
                                                    </label>
                                                </div>
                                                ) : ('')}
                                            </div>
                                        </div>
                                    ))
                                )
                            )}
                        </div>
                    ) : (
                    <table>
                        <thead>
                            <tr style={{ cursor: 'pointer' }}>
                                <th style={{ textAlign: 'center' }} className={getClassNamesFor('ageData')} onClick={() => requestSort('ageData')}>Data</th>
                                <th style={{ textAlign: 'left' }} className={getClassNamesFor('ageDescricao')} onClick={() => requestSort('ageDescricao')}>Descrição</th>
                                <th style={{ textAlign: 'left' }} className={getClassNamesFor('ageObservacoes')} onClick={() => requestSort('ageObservacoes')}>Observações</th>
                                <th style={{ textAlign: 'center' }} className={getClassNamesFor('ageStatus')} onClick={() => requestSort('ageStatus')}>Status</th>
                                <th style={{ textAlign: 'center' }} className={getClassNamesFor('ageAnexo')} onClick={() => requestSort('ageAnexo')}>Anexo</th>
                                {parseInt(sessionStorage.pesAdmin) === 1 ? <th style={{ textAlign: 'center' }} className={getClassNamesFor('ageAtivo')} onClick={() => requestSort('ageAtivo')}>Alt</th> : ''}
                            </tr>
                        </thead>
                        <tbody>
                        {
                            isLoadingMOD ? 
                            <tr>
                                <td colSpan="6" style={{ width: "100%", textAlign: "center"}}>
                                    <CircularProgress />
                                </td>
                            </tr> :
                            items.length === 0 ? <tr><td colSpan="6" style={{ width: "100%", textAlign: "center"}}>Nenhuma agenda cadastrada</td></tr> :
                            items
                            .filter(val => {
                                //return val;
                            if (searchTerm === '') {
                                //return val
                                if(sessionStorage.selectStatusRegistroAgendas !== undefined && sessionStorage.selectStatusRegistroAgendas === '99')
                                {
                                    return val
                                }
                                else if (sessionStorage.selectStatusRegistroAgendas !== undefined && sessionStorage.selectStatusRegistroAgendas !== '99')
                                {
                                    if(parseInt(sessionStorage.selectStatusRegistroAgendas) === parseInt(val.ageStatus))
                                    {
                                    return val
                                    }
                                }
                                else{
                                    return val
                                }
                            } 
                            else if (
                                val.ageData
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase()) 
                                ||
                                val.ageDescricao
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase()) 
                                ||
                                val.ageObservacoes
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase()) 
                            ) {
                                if(sessionStorage.selectStatusRegistroAgendas !== undefined && sessionStorage.selectStatusRegistroAgendas === '99')
                                {
                                    return val
                                }
                                else if (sessionStorage.selectStatusRegistroAgendas !== undefined && sessionStorage.selectStatusRegistroAgendas !== '99')
                                {
                                    if(parseInt(sessionStorage.selectStatusRegistroAgendas) === parseInt(val.ageStatus))
                                    {
                                    return val
                                    }
                                }
                                else{
                                    return val
                                }
                            }
                            })
                            .map(agenda => (
                                <tr style={{ cursor: 'pointer' }} key={agenda.IdAgenda} id={`agenda-${agenda.IdAgenda}`} >
                                    <td id={`agenda-${agenda.IdAgenda}`} className="tdAlignCenter w10" onClick={() => handleEditAgenda(agenda)}>
                                        { new Intl.DateTimeFormat('pt-BR').format(new Date(agenda.ageData))}
                                    </td>
                                    <td id={`agenda-${agenda.IdAgenda}`} style={{textTransform: 'uppercase', width: 'auto'}} onClick={() => handleEditAgenda(agenda)}>
                                        {agenda.ageDescricao}
                                    </td>
                                    <td id={`agenda-${agenda.IdAgenda}`} style={{textTransform: 'uppercase', width: 'auto'}} onClick={() => handleEditAgenda(agenda)}>
                                        {agenda.ageObservacoes}
                                    </td>
                                    <td id={`agenda-${agenda.IdAgenda}`} style={{textTransform: 'uppercase', width: 'auto'}} onClick={() => handleEditAgenda(agenda)}>
                                        {parseInt(agenda.ageStatus) === 1 ? 'ATIVA' : 'INATIVA'}
                                    </td>
                                    <td className='tdAlignCenter'
                                        onClick={agenda.ageAnexo 
                                    ? () => handleExibirPDF(agenda) : null} >
                                        {agenda.ageAnexo ? 
                                        <button className="buttonGridPadrao" >
                                            Anexo
                                        </button> : ''}
                                    </td>
                                    {parseInt(sessionStorage.pesAdmin) === 1 ? 
                                    <td className='tdAlignCenter'>
                                        <label id={`agenda-${agenda.IdAgenda}`} onClick={() => {handleChangeStatus(agenda)}}>
                                            {parseInt(agenda.ageStatus) === 1 
                                            ? 
                                            <ThumbUpAlt style={{ color: 'green', marginRight: '5px', marginBottom: '-5px', cursor: 'pointer' }} /> 
                                            : 
                                            <ThumbUpAlt style={{ color: 'red', marginRight: '5px', marginBottom: '-5px', cursor: 'pointer' }} />}
                                        </label>
                                    </td>
                                    : ''}
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>
                    )}
                </div>

            </main>
        </div>
    );
}

export default Agendas;
